module.exports = __webpack_public_path__ + "img/Systemplanningselect.71c1cdc3.svg";